import api from "./api";

export type ScheduleVisitOutcome = "completed" | "no_show";

export async function updateScheduleVisitOutcome(
  scheduleIds: number[],
  outcome: ScheduleVisitOutcome
): Promise<void> {
  await api.put("/api/adm/schedules/visit-outcome", {
    schedule_ids: scheduleIds,
    outcome,
  });
}
